import type { NodeProps } from '@xyflow/react'
import { useSelector } from 'react-redux'
import { BaseNode } from 'uikit/graphs/default'
import type { NetworkNodeData } from '../types'
import { IDENTITY_NODE_SIZE } from '../constants'
import { selectPlatform } from 'store/global'
import defaultAvatar from '../../assets/default-avatar.svg'
import { cn } from 'utils/classnames'
import styles from './nodes.module.scss'

export function IdentityNode({ data, selected }: NodeProps) {
  const nodeData = data as NetworkNodeData
  const { metadata } = nodeData
  const platform = useSelector(selectPlatform)

  const isOnPrem = platform === 'prem'
  const hasPhoto = !!metadata?.photo_url

  const imageSrc = isOnPrem || !hasPhoto ? defaultAvatar : metadata.photo_url

  return (
    <BaseNode
      selected={selected}
      nodeData={nodeData}
      isConnectable={nodeData.isConnectable}
      className={cn(styles.identityShape, styles.identityBg)}
      selectedClassName={styles.identityShape}
      labelClassName={styles.identityLabel}
      nodeSize={IDENTITY_NODE_SIZE}
    >
      <img src={imageSrc} alt='Identity' className={styles.nodeIcon} />
    </BaseNode>
  )
}
